export default __webpack_public_path__ + "static/media/frigider.f763ee15.jpg";